package dev.lingvo.site.components.studio.fonts

import dev.lingvo.shared.screenshots.text.Script
import dev.lingvo.shared.screenshots.text.Scripts

/** Starts stylesheet and native subset downloads before the person presses Compose. */
fun projectFontRequests(locales: List<String>): List<FontLoadRequest> = locales.distinct().flatMap { locale ->
    val script = Scripts.scriptFor(locale)
    val row = Scripts.rows.getValue(script)
    val sample = when (script) {
        Script.JAPANESE -> "日本語の設定こんにちは"
        Script.HANS -> "简体中文设置你好"
        Script.HANT, Script.HK -> "繁體中文設定你好"
        Script.KOREAN -> "한국어 설정 안녕하세요"
        Script.ARABIC, Script.URDU -> "مرحبا إعدادات اردو"
        Script.HEBREW -> "שלום הגדרות"
        Script.DEVANAGARI -> "नमस्ते सेटिंग"
        Script.BENGALI -> "বাংলা"
        Script.GUJARATI -> "ગુજરાતી"
        Script.GURMUKHI -> "ਪੰਜਾਬੀ"
        Script.KANNADA -> "ಕನ್ನಡ"
        Script.MALAYALAM -> "മലയാളം"
        Script.TAMIL -> "தமிழ்"
        Script.TELUGU -> "తెలుగు"
        Script.THAI -> "สวัสดี"
        Script.KHMER -> "ភាសាខ្មែរ"
        Script.MYANMAR -> "မြန်မာ"
        Script.CYRILLIC -> "Привет настройки"
        Script.GREEK -> "Γεια ρυθμίσεις"
        Script.VIETNAMESE -> "Tiếng Việt"
        Script.LATIN -> "Lingvo"
    }
    listOf(row.sans).map { family ->
        FontLoadRequest(family, sample = sample, locale = locale)
    }
}.distinctBy { it.copy(locale = "") }
